import React from 'react';

export default function Invitation(){
  return (
    <div className="container">
      <h2>You're Invited!</h2>
      <p>Thank you — your RSVP has been recorded. See you at the event!</p>
    </div>
  );
}
